// extracted by mini-css-extract-plugin
export default {"brandBlock":"LoginHead_brandBlock__L30bz","loginLogo":"LoginHead_loginLogo__n2h5C"};